import React, { PropsWithChildren, memo } from 'react';
import { createContext, useContext } from 'react';
import { BookerContextType } from './types';

const BookerContext = createContext<BookerContextType | null>(null);

export const useBookingContext = () => {
    const context = useContext(BookerContext);
    if (!context) {
        throw new Error(
            'useBookingContext must be used within a BookerLoggerProvider'
        );
    }
    return context;
};

export const BookerContextProvider = memo(
    ({ children, ...props }: PropsWithChildren<BookerContextType>) => {
        const contextValue: BookerContextType = {
            ...props,
        };

        return (
            <BookerContext.Provider value={contextValue}>
                {children}
            </BookerContext.Provider>
        );
    }
);
